import { render, staticRenderFns } from "./RecipientsSettings.vue?vue&type=template&id=0ce55459&scoped=true&"
import script from "./RecipientsSettings.vue?vue&type=script&lang=js&"
export * from "./RecipientsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce55459",
  null
  
)

export default component.exports